import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2.4rem;
    height: 100%;
    color: ${tokens.secondary.dark};
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
`;

export const Icon = styled(FontAwesomeIcon)`
    font-size: 4.8rem;
    color: ${tokens.secondary.dark};
`;
